import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { feesMasterKeys } from '../feesMasterQueryKeys'
import { supersedeFeeDefinition } from '../feesMasterEndpoints'
import type { SupersedeFeeDefinitionPayload } from '../feesMasterContracts'

export function useSupersedeFeeDefinitionMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: SupersedeFeeDefinitionPayload }) =>
      supersedeFeeDefinition(id, payload),
    // The superseded row keeps its own history under its old id, so both the
    // list and that id's version list have to refetch.
    onSuccess: (_data, { id }) => {
      qc.invalidateQueries({ queryKey: feesMasterKeys.lists() })
      qc.invalidateQueries({ queryKey: feesMasterKeys.detail(id) })
    },
  })
}
